/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ListHealthResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * HealthAPIApi - axios parameter creator
 * @export
 */
export const HealthAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets the list of services\' health.
         * @summary List services health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthAPIListHealth: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/services/v1/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthAPIApi - functional programming interface
 * @export
 */
export const HealthAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets the list of services\' health.
         * @summary List services health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthAPIListHealth(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHealthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthAPIListHealth(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthAPIApi.healthAPIListHealth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthAPIApi - factory interface
 * @export
 */
export const HealthAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthAPIApiFp(configuration)
    return {
        /**
         * Gets the list of services\' health.
         * @summary List services health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthAPIListHealth(options?: RawAxiosRequestConfig): AxiosPromise<ListHealthResponse> {
            return localVarFp.healthAPIListHealth(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthAPIApi - object-oriented interface
 * @export
 * @class HealthAPIApi
 * @extends {BaseAPI}
 */
export class HealthAPIApi extends BaseAPI {
    /**
     * Gets the list of services\' health.
     * @summary List services health.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthAPIApi
     */
    public healthAPIListHealth(options?: RawAxiosRequestConfig) {
        return HealthAPIApiFp(this.configuration).healthAPIListHealth(options).then((request) => request(this.axios, this.basePath));
    }
}

